import _ from 'lodash'

// Get the LO Id from a given string in curCard meta
export function extractLoId (meta) {
  const idString = _.get(meta, 'learning_objectives', null)
  if (idString === null) return idString
  const arr = idString.split('"objective":')
  if (arr[1]) {
    return arr[1].replace(/[[\]{}"]/g, '')
  } else {
    return null
  }
}
